import { omit } from 'lodash'

export function makeFields (data) {
  const excludeEditData = [
    'id',
    'school_id',
    'class_id',
    'session_id',
    'online_application_form_id',
    'application_id',
    'student_first_name',
    'student_last_name',
    'dob',
    'gender',
    'nationality',
    'aadhaar_no',
    'category',
    'language',
    'require_transport',
    'transport_pickup_point',
    'visible_tattoo',
    'contact_country_code',
    'contact_phone',
    'contact_email',
    'contact_address',
    'contact_city',
    'contact_district',
    'contact_landmark',
    'contact_state',
    'contact_pincode',
    'contact_country',
    'father_suffix',
    'father_first_name',
    'father_last_name',
    'father_contact_country_code',
    'father_contact_phone',
    'father_qualification',
    'father_occupation',
    'mother_suffix',
    'mother_first_name',
    'mother_last_name',
    'mother_contact_country_code',
    'mother_contact_phone',
    'mother_qualification',
    'mother_occupation',
    'guardian_suffix',
    'guardian_first_name',
    'guardian_last_name',
    'guardian_contact_country_code',
    'guardian_contact_phone',
    'guardian_qualification',
    'guardian_occupation',
    'applicant_marks',
    'subject_group',
    'photo',
    'document',
    'sports_person',
    'sport_cert',
    'password',
    'step',
    'form_status',
    'status',
    'token',
    'uniforms',
    'order_id',
    'created_at',
    'updated_at',
    'deleted_at',
    'student_id',
  ]
  const editData = omit(data, excludeEditData)

  const marks = data.applicant_marks
  const marksData = {}

  marks.forEach((element, index) => {
    marksData['marks[' + index + '][subject]'] = element.subject
    marksData['marks[' + index + '][score]'] = element.score
    marksData['marks[' + index + '][full_mark]'] = element.full_mark
    marksData['marks[' + index + '][status]'] = element.status
  })

  const uniforms = data.uniforms
  const uniformsData = {}

  uniforms.forEach(element => {
    uniformsData['uniform_type_sizes[' + element.uniform_type_id + '][uniform_size_id]'] = element.uniform_size_id
    if (element.uniform_type_variant_id) {
      uniformsData['uniform_type_sizes[' + element.uniform_type_id + '][uniform_type_variant_id]'] = element.uniform_type_variant_id
    }
  })

  console.log({ ...editData, ...marksData, ...uniformsData })

  return { ...editData, ...marksData, ...uniformsData }
}
